export type MunilyAvatarSize = 'small' | 'medium' | 'large';
export type MunilyAvatarObjectFit = 'contain' | 'cover';

export const MUNILY_AVATAR_DEFAULTS = {
  size: 'medium' as MunilyAvatarSize,
  objectFit: 'cover' as MunilyAvatarObjectFit,
  initials: '',
  alt: '',
  backgroundColor: '',
} as const;
